import { getViewerSpecificRole } from './library';

export default function getRoleBasedPath(props, path = '') {
  const specificRole = getViewerSpecificRole(props);
  return (
      specificRole === 'SELLER_MERCHANT'
    ? `/store${path}`
    : specificRole === 'SELLER_REFERRAL'
    ? `/store/partners${path}`
    : specificRole === 'SELLER_RESELLER'
    ? `/store/reseller${path}`
    : `${path}`
  );
}
